import React, { useContext } from "react";

// Third-party
import PropTypes from "prop-types";

// Context
import ResultsProvider from "context/ResultsContext";
import CorridorsProvider from "context/CorridorsContext";
import PathsProvider from "context/PathsContext";
import ResistanceMapsProvider from "context/ResistanceMapsContext";
import ComparisonMapsProvider from "context/ComparisonMapsContext";
import SitesProvider from "context/SitesContext";

import { AppContext } from "AppProvider";

function AllResults({ children }) {
  const appContext = useContext(AppContext);

  return (
    <ResultsProvider>
      <ResistanceMapsProvider
        scenarios={appContext.scenarios}
        activeScenarioId={appContext.scenarios[appContext.active_scenario]?.id}
        projectId={appContext.project.id}
      >
        <ComparisonMapsProvider
          scenarios={appContext.scenarios}
          activeScenarioId={
            appContext.scenarios[appContext.active_scenario]?.id
          }
          projectId={appContext.project.id}
        >
          <CorridorsProvider
            scenarios={appContext.scenarios}
            activeScenarioId={
              appContext.scenarios[appContext.active_scenario]?.id
            }
            projectId={appContext.project.id}
          >
            <PathsProvider
              scenario={appContext.scenario}
              scenarios={appContext.scenarios}
              activeScenarioId={
                appContext.scenarios[appContext.active_scenario]?.id
              }
              projectId={appContext.project.id}
            >
              <SitesProvider
                scenario={appContext.scenario}
                scenarios={appContext.scenarios}
                activeScenarioId={
                  appContext.scenarios[appContext.active_scenario]?.id
                }
                projectId={appContext.project.id}
              >
                {children}
              </SitesProvider>
            </PathsProvider>
          </CorridorsProvider>
        </ComparisonMapsProvider>
      </ResistanceMapsProvider>
    </ResultsProvider>
  );
}

AllResults.propTypes = {
  children: PropTypes.node.isRequired
};

export default AllResults;
